import { render } from "./auditoria.vue?vue&type=template&id=4171cecb&scoped=true"
import script from "./auditoria.vue?vue&type=script&lang=js"
export * from "./auditoria.vue?vue&type=script&lang=js"

import "./auditoria.vue?vue&type=style&index=0&id=4171cecb&lang=scss&scoped=true"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4171cecb"]])

export default __exports__